import { Button } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

type TableActionButtonProps = {
  id?: string;
  onClick: () => void;
  disabled?: boolean;
  ariaLabel?: string;
};

function TableActionButton({ id, onClick, disabled, ariaLabel = 'Ações' }: TableActionButtonProps) {
  return (
    <Button
      id={id}
      shape='circle'
      onClick={onClick}
      disabled={disabled}
      type='text'
      icon={<Icon.Ellipsis />}
      aria-label={ariaLabel}
    />
  );
}

export { TableActionButton };
